import { FormattedMessage, injectIntl } from 'react-intl';
import { Divider, Modal, Button, Tag, Statistic } from 'antd';

import queryString from 'query-string';
import Container from '../Container/Container';
import React, { Component, useEffect, useState, useContext } from 'react';
import Router from 'next/router';
import getConfig from 'next/config';
import myContext from '@/utils/createContext';
import { gtag, sessionStorage, reportEventToMonitor } from '@/utils'

const { Countdown } = Statistic;

const { warning } = Modal;


import {
	CommonHandleCancelPayment,
  } from '@/components/H5PC/CommonMethod';


const { publicRuntimeConfig } = getConfig();
// 从环境变量中取MODE，配置在next.config.js和package.json文件中
const ENV = publicRuntimeConfig.env.NEXT_PUBLIC_ENV;

function Footer(props) {
  const [editModalVisible, setEditModalVisible] = useState(false); // 控制编辑卡弹窗显示隐藏
  const [lang, setLang] = useState('en-US'); // 控制编辑卡弹窗显示隐藏
  // const [isFixed, setIsFixed] = useState(false); // 一开始固定
  const { intl } = props;
  const { formatMessage } = intl;

  const {
    cashierData,
    resData, 
	key, 
	isMobileView,
	showDomain,
  fontColor
  } = useContext(myContext)

  // console.log(resData)
  //只浙大收银台返回ablePaymentCurrencyList
  let { ablePaymentCurrencyList, ttl } = cashierData || {}

  if (Number(ttl) < 0) { 
    ttl = 0
  }

  const deadline = Date.now() + ttl * 1000 || '';


  function onFinish() {
    Router.push('/time-out')
    return
  }

  useEffect(() => {
    const search = getLocalstorageLocale() || 'en-US';
    // if (search.indexOf('es') > -1) {
    //   setLang('es');
    // } else {
    //   setLang('en');
    // }
    setLang(search);
    const footerTimeENd = new Date().getTime();

    const documentTime = footerTimeENd - Number(sessionStorage.getItem('llPay_startTime'));
    // console.log(documentTime);

    // documentTime >= 30000 && reportEventToMonitor(`页面加载超时报警(cashier_document_time): time=${documentTime}ms; `)
    
  }, []);

  const showEditModalVisible = () => {
    setEditModalVisible(true);
    stopBodyScroll(true);
  };

  const hideEditModalVisible = () => {
    setEditModalVisible(false);
    stopBodyScroll(false);
  };

  const getLocalstorageLocale = () => {
    return localStorage.getItem('locale');
  };

  const onClick = lang => {
    setLang(lang);
    const pathname = window.location.pathname;
    const search = location.search;
    let href = `${pathname}${search}`;
    localStorage.setItem('locale', lang);
    Router.push(`${href}`);
  };
  const handleLangChange = e => {
    const target = e.target;
    const lang = target.value;

    console.log(e.target.value);

    gtag(`${showDomain}支付页面`, [new Date() + '选择语言', lang]);
    gtag(`${showDomain}支付页面`, ['选择语言', lang]);
    gtag(`定制支付页面`, ['选择语言', lang]);

    // 动态改变语言选择框的长度
    const selectObj = e.target;

    setTimeout(() => {
      let myWidth;
      const selectedHtml = selectObj[selectObj.selectedIndex].innerHTML;
      const len = selectedHtml.length;
      // 判断是否为中文汉字
      if (
        /^(?:[\u3400-\u4DB5\u4E00-\u9FEA\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0])+$/.test(
          selectedHtml,
        )
      ) {
        myWidth = len * 20;
      } else {
        myWidth = len * 10;
      }
      target.style.width = '';
      target.style.width = myWidth + 'px';
    }, 10);

    setLang(lang);
    const pathname = window.location.pathname;
    const search = location.search;
    let href = `${pathname}${search}`;
    localStorage.setItem('locale', lang);
    // if (lang === 'en') {
    //   localStorage.setItem('locale', 'en-US');
    // } else {
    //   localStorage.setItem('locale', 'es-ES');
    // }
    Router.push(`${href}`);
  };
  const footerBtn = () => {
    return (
      <Button type="link" onClick={hideEditModalVisible}>
        Got it
      </Button>
    );
  };
  let bodyEl = document.body;
  let top = 0;

  const stopBodyScroll = isFixed => {
    if (isFixed) {
      top = window.scrollY;
      bodyEl.style.position = 'fixed';
      bodyEl.style.top = -top + 'px';
    } else {
      bodyEl.style.position = '';
      bodyEl.style.top = '';
      window.scrollTo(0, top); // 回到原先的top
    }
  };
  return (
    <footer className="h5-footer">
      <Container>
        <div className="h5pc-footer-panel">
         
          <div className="h5-copyright">
            <div className="h5-footer-other-icon footer-bg-visa"></div>
            <div className="h5-footer-other-icon footer-bg-mastercard"></div>
            <div className="h5-footer-other-icon footer-bg-jcb"></div>
            <div className="h5-footer-other-icon footer-bg-3ds"></div>
            {/*<div className="footer-other-divider">|</div>*/}
            {/* <div className="h5-footer-icon footer-bg-pci"></div> */}
          </div>
		  <div className="vh5pc-footer-bottom-container">
			<div className="h5pc-footer-panel-language">
          <select
            className="my-native-select"
            onChange={handleLangChange}
            defaultValue={getLocalstorageLocale() || 'en-US'}
          >
            {/* United States, Canada, United Kingdom, France, Australia, Germany */}
            
            <option value="en-US">
              {formatMessage({ id: 'nav.english' })}
                </option>
                <option value="pt-BR">
                  {formatMessage({ id: 'nav.portuguese' })}
                </option>
            <option value="zh-CN">
              {formatMessage({ id: 'nav.chinese' })}
            </option>
            <option value="zh-TW">
              {formatMessage({ id: 'nav.chinese-tw' })}
            </option>
                <option value="ja-JP">
                  {formatMessage({ id: 'nav.japanese' })}
                </option>
          </select>
          {/* <span
            className="h5pc-footer-panel-language-text"
            style={{ color: lang === 'pt-BR' ? '#444' : '#ccc' }}
            onClick={() => onClick('pt-BR')}
          >
            <FormattedMessage id="nav.portuguese" />
          </span>
          <Divider type="vertical" style={{ margin: '0 10px' }} />
          <span
            className="h5pc-footer-panel-language-text"
            style={{ color: lang === 'en-US' ? '#444' : '#ccc' }}
            onClick={() => onClick('en-US')}
          >
            <FormattedMessage id="nav.english" />
          </span> */}
        </div>
		  </div>
        </div>
        <Modal
          // className="h5-footer-privacy-modal"
          wrapClassName="h5-footer-privacy-modal"
          centered={true}
          visible={editModalVisible}
          onCancel={hideEditModalVisible}
          footer={footerBtn()}
          title="Privacy Policy"
          width="80%"
          height="80%"
          closable={false}
        >
          <iframe
            src="https://acquiring.lianlianpay.com/privacy"
            width="100%"
            height="100%"
            frameBorder="none"
          />
        </Modal>
        {deadline && (
          <Countdown
            className="header-countdown-time"
            style={{display: "none"}}
            value={deadline}
            onFinish={onFinish}
            valueStyle={{ fontSize: '18px' }}
          />
          )}
      </Container>

      {/* {ENV !== 'production' ? (
        <div>
          <Tag color="#108ee9">{ENV}</Tag>
        </div>
      ) : null} */}

      <noscript>
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KT5SQ4ZR" height="0" width="0"
          style="display:none;visibility:hidden"></iframe>
      </noscript>
    </footer>
  );
}

export default injectIntl(Footer);
